import { createReducer } from '@reduxjs/toolkit';

import getRoleDetails from '../../thunks/roles/getRoleDetails';

const initialState = {
  loading: false,
  error: null,
  role: undefined
};

const getRoleDetailsReducer = createReducer(initialState, {
  [getRoleDetails.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getRoleDetails.fulfilled]: (state, { payload: role }) => ({
    ...state,
    loading: false,
    role
  }),
  [getRoleDetails.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    role: undefined
  }),
});

export default getRoleDetailsReducer;
